<script>
import baseList from "@/views/components/base/baseList.vue";
import ImportTemplate from "@/views/components/common/form/sceneImportTemplate.vue";
let customerId = window.localStorage.getItem("customerId");
import { Tag, Button } from "view-design";
import config from "@/../config";
import Vue from "vue";
export default {
  extends: baseList,
  components: {
    ImportTemplate,
  },
  data() {
    return {
      table: {
        mname: "scene",
        key: "id",
        url: {
          del: "/admin/system/scene",
        },
        output: false,
      },
      actions: [
        {
          label: "新增",
          icon: "md-add",
          onClick: this.toAdd,
          type: "info",
          auth: "system/scene/add",
        },
        {
          label: "导入",
          icon: "md-cloud-upload",
          onClick: this.toImport,
          type: "info",
          auth: "",
        },
        {
          label: "下载模板",
          icon: "md-log-out",
          onClick: this.toDownload,
          auth: "",
          type: "info",
        },
      ],
      menus: [],
      filters: [
        {
          label: "巡检项",
          KeyEnter: this.search,
          name: "sceneName",
          value: "",
          type: "input",
        },
      ],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "巡检项",
          key: "sceneName",
          minWidth: 200,
          align: "left",
        },
        // {
        //   title: '场景地址',
        //   key: 'address',
        //   minWidth: 120,
        //   align: 'left',
        // },
        {
          title: "创建时间",
          width: 150,
          align: "center",
          key: "createTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.createTime.slice(0, 16);
            // console.log(text);
            let result = "";
            var n = 10; //指定第n位换行
            for (var i = 0, len = text.length; i < len; i++) {
              result += text[i];
              if ((i + 1) % n == 0) result += "\r\n";
            }
            return <span>{result}</span>;
          },
        },
        // {
        //   title: '备注',
        //   minWidth: 180,
        //   align: 'left',
        //   key: 'remark',
        // },
        {
          title: "操作",
          align: "center",
          width: 150,
          key: "handle",
          fixed: "right",
          handle: ["edit", "delete"],
          auth: {
            edit: "system/scene/edit",
            del: "system/scene/delete",
          },
        },
      ],
      hospitalId: [],
    };
  },
  created() {
    let customerId = localStorage.getItem("customerId");
    if (customerId == 0) {
      this.actions.push({
        label: "推送",
        onClick: this.onPush,
        type: "info",
        auth: "",
      });
    }
  },
  methods: {
    toAdd() {
      $utils.url.push({ name: "scene_add", query: { action: "add" } });
    },
    handleEdit(row) {
      let kv = row.id;
      $utils.url.push({
        name: "scene_edit",
        query: { action: "edit", kv: kv },
      });
    },
    onPush() {
      let that = this;
      $utils.api
        .load("/admin/system/customer/listByAdmin", {}, "get")
        .then((res) => {
          let resList = res.rows;
          this.$Modal.success({
            closable: true,
            title: "推送",
            width: "50rem",
            okText: "取消",
            showOk: false,
            render: (h) => {
              return (
                <div>
                  <div style="display:flex;align-items:center;width:100%;padding-top:3.125rem;">
                    <div style="width:6.25rem">医院选择：</div>
                    <Select v-model={that.hospitalId} multiple={true}>
                      {resList.map((item) => {
                        return (
                          <Option
                            label={item.customerName}
                            value={item.id}
                            key={item.id}
                          ></Option>
                        );
                      })}
                    </Select>
                  </div>
                  <div style="margin-top:6.25rem;width:100%; display:flex;justify-content:right;">
                    <Button
                      size="large"
                      type="info"
                      style="width: 9.375rem;"
                      onClick={() => {
                        that.onPushOk();
                      }}
                    >
                      确定
                    </Button>
                  </div>
                </div>
              );
            },
          });
        });
    },
    async onPushOk() {
      let hospitalIds = this.hospitalId.join(",");
      let res = await $utils.api.load(
        `/admin/system/scene/push/${hospitalIds}`,
        {},
        "get"
      );
      if (res.code == 200) {
        this.$Modal.remove();
        $utils.toast.success(res.msg);
      }
    },
    toImport() {
      this.$Modal.success({
        closable: true,
        title: "导入模板",
        width: "1200px",
        height: "900px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <ImportTemplate
              style={{ margin: "0", color: "#19be6b" }}
              refListTable={() => {
                this.search();
              }}
            >
              {" "}
            </ImportTemplate>
          );
        },
      });
    },
    toDownload() {
      window.location.href =
        config.API_HOST + `/admin/system/scene/template/download`;
    },
  },
};
</script>
<style scoped></style>
